import 'components/DiscoveryTasks/DiscoveryTasks.css';
import type { BgpCommunities } from '@ipfabric/utils/settings/types/types';
import { BgpDataTransferManager } from 'components/BgpSettings/dataTransfer/BgpDataTransferManager';
import { type FC, memo, useState } from 'react';
import { BgpCommunitiesList } from './BgpCommunitiesList';
import { BgpDeviceForm } from './BgpDeviceForm';

interface Props {
  bgps: BgpCommunities[];
  onBgpsChange: (bgps: BgpCommunities[]) => void;
}

const BareBgpSettings: FC<Props> = (props) => {
  const [isDataTransferManagerOpen, setIsDataTransferManagerOpen] =
    useState(false);
  const [isEditDeviceDialogOpen, setIsEditDeviceDialogOpen] = useState(false);
  const [editedItem, setEditedItem] = useState<BgpCommunities | null>(null);

  const handleDelete = (id: string) => {
    props.onBgpsChange(props.bgps.filter((bgp) => bgp.id !== id));
  };

  return (
    <>
      {isDataTransferManagerOpen && (
        <BgpDataTransferManager
          existingBgpEntries={props.bgps}
          onClose={() => setIsDataTransferManagerOpen(false)}
          onImportSuccess={(data, replaceEntries) => {
            if (replaceEntries) {
              // replace all entries in BGP table
              props.onBgpsChange(data);
            } else {
              // add valid entries to BGP table
              props.onBgpsChange([...props.bgps, ...data]);
            }
          }}
        />
      )}
      {isEditDeviceDialogOpen && (
        <BgpDeviceForm
          formType={editedItem ? 'edit' : 'add'}
          onClose={() => {
            setIsEditDeviceDialogOpen(false);
            setEditedItem(null);
          }}
          editedItem={editedItem}
          onSubmit={(values) => {
            props.onBgpsChange(
              editedItem
                ? props.bgps.map((bgp) => (bgp.id === values.id ? values : bgp))
                : [...props.bgps, values],
            );
          }}
        />
      )}
      <BgpCommunitiesList
        bgps={props.bgps}
        onDelete={handleDelete}
        onAddDeviceClick={() => {
          setIsEditDeviceDialogOpen(true);
        }}
        onEditDevice={(bgp) => {
          setEditedItem(bgp);
          setIsEditDeviceDialogOpen(true);
        }}
        onImportExportClick={() => {
          setIsDataTransferManagerOpen(true);
        }}
      />
    </>
  );
};

export const BgpSettings = memo(BareBgpSettings);
